// Unpublished Work © 2023-2024 Deere & Company.

export const ASSIGNMENT_MOBILE_MEDIA_QUERY = {
    prop: 'isAssignmentMobile',
    query: '(max-width: 1120px)'
};
